import DocPermissionEnum from 'enums/DocPermissionEnum';

const mergeArraysById = (originalArray, updatedArray) => {
  const updatedItemsById = new Map(updatedArray?.map((item) => [item._id, item]));
  const mergedArray = originalArray?.map((originalItem) => {
    const updatedItem = updatedItemsById.get(originalItem?._id);
    if (updatedItem) {
      return {
        ...updatedItem,
        actions: [
          DocPermissionEnum.DOC_OWN,
          DocPermissionEnum.DOC_VIEW,
          DocPermissionEnum.DOC_EDIT,
          DocPermissionEnum.DOC_DOWNLOAD
        ]
      };
    }
    return originalItem;
  });
  return mergedArray;
};

export default mergeArraysById;
